import './MainPage.css';
import logo from '../../image/Logo.svg';
// import saveIcon1 from '../../image/SaveIcon-white.svg';
// import saveIcon2 from '../../image/SaveIcon-orange.svg';
import chevronDown from '../../image/chevron-down.svg';

import Childdata from '../Childdata/Childdata';
import ChartBlock from '../ChartBlock/ChartBlock';
import AboutChild from '../AboutChild/AboutChild';

import ColorContainer from '../ColorContainer/ColorContainer';
import { useState, useCallback, useEffect, useRef } from 'react';
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import Alert from '@mui/material/Alert';
import { handleRequest } from '../Helpers/Helpers';
import linkIcon from '../../image/link-45deg.svg';

const wait = (delay) => new Promise(r => setTimeout(r, delay))

const exportPage = async (title, format) => {
	await wait(100)
	const windowWidth = 1200;

	const onclone = (clonedDocument) => {
		Array.from(
			clonedDocument.querySelectorAll(
				'textarea:not([aria-hidden="true"])'
			)
		).forEach(textArea => {
			if (textArea.value.length > 0) {
				const div = clonedDocument.createElement('div')
				div.innerText = textArea.value
				div.className = textArea.className
				textArea.replaceWith(div)
			}
		})
	}

	const canvas = await html2canvas(document.body, {
		width: windowWidth,
		windowWidth,
		scrollX: 0,
		scrollY: 0,
		x: 0,
		y: 0,
		ignoreElements: (element) =>
			element.getAttribute('export-ignore') === 'true',
		onclone,
	})
	const canvasDataUrl = canvas.toDataURL('image/png')

	if (format === 'pdf') {
		const pdf = new jsPDF({
			orientation: 'portrait',
			unit: 'px',
			format: [canvas.width, canvas.height],
		})
		pdf.addImage(canvasDataUrl, 'PNG', 0, 0, canvas.width, canvas.height)
		pdf.save(`${title}.pdf`)
	} else if (format === 'jpg') {
		const a = document.createElement('a')
		a.href = canvasDataUrl
		a.setAttribute('download', `${title}.jpg`)
		a.click()
		a.remove()
	}
}

const lessonList = [
	{ name: "Общее", value: "general" },
	{ name: "Английский язык", value: "english" },
	{ name: "Логопед", value: "speech" }
];

const defaultInputData = {
	parent_comment: '',
	month_goals: '',
	lesson_comment: '',
	favorite_characters: '',
	interests: '',
	likes_dislikes: ''
}


function MainPage() {
	const [name, setName] = useState('');
	const [childIsPicked, setChildIsPicked] = useState(false);
	const [selectedClientId, setSelectedClientId] = useState('');
	const [selectedChildId, setSelectedChildId] = useState('');
	const [selectedChildName, setSelectedChildName] = useState('');
	const [assessmentDate, setAssessmentDate] = useState(() => new Date());
	const [teacherName, setTeacherName] = useState('');
	const [teacherId, setTeacherId] = useState(null);
	const [isLoading, setIsLoading] = useState({ parent: false, teacher: false });
	const [visibleSliderBlock, setVisibleSliderBlock] = useState({ dateBirth: false, direction: false });
	const [criterionRequestParam, setCriterionRequestParam] = useState({ dateBirthValue: '', direction: '', dateBirthName: '' });
	const [fileFormat, setFileFormat] = useState('pdf');
	const [listLessonSkill, setListLessonItems] = useState([]);
	const [criterionError, setCriterionError] = useState('');

	const [studentParametersValues, setSudentParametersValues] = useState([]);
	const [lessonName, setLessonName] = useState({ name: "Не выбрано", value: "general" });
	const [exportingFor, setExportingFor] = useState(null);
	// const [width, setWidth] = useState(window.innerWidth);
	const [isRotatedLesson, setIsRotatedLesson] = useState(false);
	const lessonRef = useRef(null);
	const [dataLastWheel, setDataLastWheel] = useState(null);
	const [visibleAlert, setVisibleAlert] = useState(false);

	const [inputData, setInputData] = useState(defaultInputData);

	const loadCriteria = (age, subject) => {
		setCriterionError('');
		return handleRequest(age, subject)
			.then((data) => {
				setListLessonItems(data);
				const skillKeys = Object.keys(data);
				const initialSkillItem = Object.fromEntries(skillKeys.map((key) => [key, 0]));
				setSudentParametersValues(initialSkillItem);
				return data;
			})
			.catch((err) => {
				const message = err?.apiMessage || err?.message || 'Не удалось загрузить критерии';
				setCriterionError(message);
				setListLessonItems([]);
				setSudentParametersValues([]);
				setVisibleSliderBlock((prev) => ({ ...prev, direction: false }));
				throw err;
			});
	};


	const setDafaultStudendParameters = () => {
		setSudentParametersValues(Object.fromEntries(
			manySkill.general.map(studentParameter => [studentParameter, 0])
		))
	}

	const setDefaultInputData = () => {
		setInputData(defaultInputData);
	}

	const dropValues = () => {
		const dateBirthValue = criterionRequestParam.dateBirthValue;
		const direction = criterionRequestParam.direction;

		if (!dateBirthValue || dateBirthValue === 'null' || !direction) {
			setDefaultInputData();
			return;
		}

		loadCriteria(dateBirthValue, direction).catch(() => {});
		setDefaultInputData();
	}

	const handleClick = (id) => {
		checkActiveLesson();
		setIsRotatedLesson(!isRotatedLesson);
		togleVisible(id);
	};

	const updateSudentParameter = (
		parameter,
		value,
	) => {
		setSudentParametersValues(prev => ({
			...prev,
			[parameter]: value,
		}))
	}

	useEffect(() => {
		if (dataLastWheel) {
			console.log("dataLastWheel", dataLastWheel);
			const data = dataLastWheel.fields;
			
			let dateBirdth = '3y';
			let dateBirdthName = '3 года';

			if (dataLastWheel.birth_date && dataLastWheel.birth_date_name) {
				dateBirdth = dataLastWheel.birth_date;
				dateBirdthName = dataLastWheel.birth_date_name;
			}

			let obj1 = {};

			for (let i = 0; i < data.length; i++) {
				let key = Object.keys(data[i])[0];
				let value = data[i][key];
				obj1[key] = value;
			}

			setCriterionRequestParam(
				prevState =>
				({
					...prevState,
					dateBirthValue: dateBirdth,
					dateBirthName: dateBirdthName,
					direction: dataLastWheel.subject.name
				}));

			setInputData(obj1);

			let obj = {};
			const json = dataLastWheel.perfomance;
			for (let i = 0; i < json.length; i++) {
				let key = Object.keys(json[i])[0];
				let value = json[i][key][0];
				obj[key] = Number(value);
			}

			if (dataLastWheel.teacher_name) {
				setTeacherName(dataLastWheel.teacher_name);
			}
			if (dataLastWheel.assessment_date) {
				const parsed = new Date(dataLastWheel.assessment_date);
				if (!Number.isNaN(parsed.getTime())) {
					setAssessmentDate(parsed);
				}
			}

			setCriterionError('');
			handleRequest(dateBirdth, dataLastWheel.subject.name)
				.then((responce) => {
					const result = {};

					for (let key in json) {
						const nestedKeys = Object.keys(json[key])[0];

						if (nestedKeys in responce) {
							result[nestedKeys] = responce[nestedKeys];
						} else {
							result[nestedKeys] = {};
						}
					}

					setListLessonItems(result);
					setSudentParametersValues(obj);
				})
				.catch((err) => {
					setCriterionError(err?.apiMessage || err?.message || 'Не удалось загрузить критерии');
					setListLessonItems([]);
					setSudentParametersValues([]);
				});

			setLessonName(dataLastWheel.subject);
		}

	}, [dataLastWheel]);

	// const handleResize = () => {
	//   setWidth(window.innerWidth);
	// };

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (lessonRef.current && !lessonRef.current.contains(event.target)) {
				const lessonDropdown = document.getElementById("addictionLesson");
				if (lessonDropdown && lessonDropdown.style.display !== "none") {
					lessonDropdown.style.display = "none";
					setIsRotatedLesson(!isRotatedLesson);
				}
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};

	}, [isRotatedLesson]);

	const download = useCallback(
		async (exportFor) => {
			// console.log("црфе", exportFor);
			setIsLoading(prevState => ({ ...prevState, [exportFor]: true }))
			setExportingFor(exportFor)
			const title = `Колесо баланса – ${name} (${exportFor === 'parent' ? 'для родителей' : 'для преподавателей'
				})`
			await exportPage(title, fileFormat)
			setExportingFor(null)
			setIsLoading(null)
			setVisibleAlert(false);
		},
		[fileFormat, name]
	)

	const handlers = {
		skill: listLessonSkill,
		updateData: updateSudentParameter,
		studentValue: studentParametersValues,
		setName: setName,
		dropValues: dropValues,
		setDataLastWheel: setDataLastWheel,
		setChildIsPicked: setChildIsPicked,
		setSelectedClientId,
		setSelectedChildId,
		setSelectedChildName,
		assessmentDate,
		setAssessmentDate,
		visibleSliderBlock: visibleSliderBlock,
		setVisibleSliderBlock: setVisibleSliderBlock,
		setDafaultStudendParameters: setDafaultStudendParameters,
		setDefaultInputData: setDefaultInputData,
		setCriterionRequestParam: setCriterionRequestParam,
		criterionRequestParam: criterionRequestParam,
		setSudentParametersValues: setSudentParametersValues,
		setListLessonItems: setListLessonItems,
		setCriterionError,
	};

	const canSave = Boolean(
		visibleSliderBlock?.direction &&
		visibleSliderBlock?.dateBirth &&
		selectedChildId
	);

	const saveContext = {
		clientId: selectedClientId,
		childId: selectedChildId,
		childName: selectedChildName || name,
		inputData,
		studentParametersValues,
		criterionRequestParam,
		lessonName,
		assessmentDate,
	};

	const handleClickHideSlider = () => {
		document.querySelector(".picked-lesson").classList.add("red-border");
		setVisibleSliderBlock(prevState => ({ ...prevState, direction: false }));
		setLessonName({ name: 'Не выбрано', value: 'general' });
	}

	return (<ColorContainer blue={exportingFor === 'parent'}>
		<Alert severity="success" export-ignore="true" sx={{
			opacity: visibleAlert ? 1 : 0,
			position: 'fixed',
			top: 0,
			zIndex: 20,
		}}>Не забудьте сохранить!</Alert>
		{criterionError ? (
			<Alert
				severity="error"
				export-ignore="true"
				onClose={() => setCriterionError('')}
				sx={{
					position: 'fixed',
					top: 48,
					left: '50%',
					transform: 'translateX(-50%)',
					zIndex: 20,
					maxWidth: '90vw',
				}}
			>
				{criterionError}
			</Alert>
		) : null}
		<div className='header'>
			<div>
				<img src={logo} className="main-logo" alt="logo" />
				<div className='link-container'>
					<a href="https://caremybaby.teamly.ru/at/3795b4a7-f435-458b-a24f-fa2baf9e0e24" target='_blank' rel="noreferrer" style={{ textDecoration: 'none' }}>
						<div className='title-container-link'>
							<img src={linkIcon} alt='link' />
							<p>Инструкции и материалы</p>
						</div>
					</a>
				</div>
			</div>

			<div>
				<h1>Колесо баланса</h1>
				<div ref={lessonRef} className='take-lesson-container'
					onClick={() => handleClick('addictionLesson')} export-ignore='true'>
					<p className='title-lesson-container'>Направление</p>
					<div className='picked-lesson red-border'>
						<p className='picked-lesson-name' id='lesson-subject' data-copy-bot name={lessonName.value}>{lessonName.name}</p>
						<img src={chevronDown} alt='chevron' style={{
							transform: isRotatedLesson ? "rotate(180deg)" : "rotate(0deg)"
						}} />
					</div>
					<div className='take-lesson-dropdown' id='addictionLesson' style={{ display: "none" }}>
						<p className='lesson-list' value='general'
							onClick={handleClickHideSlider}>
							Не выбрано
						</p>
						<DisplayLessonList
							setDataSkill={setListLessonItems}
							setDataName={setLessonName}
							updateSkillItem={setSudentParametersValues}
							setVisibleSliderBlock={setVisibleSliderBlock}
							criterionRequestParam={criterionRequestParam}
							setCriterionRequestParam={setCriterionRequestParam}
							setCriterionError={setCriterionError} />
					</div>
				</div>

			</div>
		</div>
		<section className='main-content'>
			<Childdata handlers={handlers} />
		</section>
		{(visibleSliderBlock.direction && visibleSliderBlock.dateBirth) && (

			<section className='main-content'>
				<ChartBlock label={listLessonSkill} studentValue={studentParametersValues} />
			</section>
		)}

		<section className='main-content'>
			<AboutChild
				exportingFor={exportingFor}
				inputData={inputData}
				setInputData={setInputData}
				visibleSliderBlock={visibleSliderBlock}
				setDefaultInputData={setDefaultInputData}
				teacherName={teacherName}
				setTeacherName={setTeacherName}
				teacherId={teacherId}
				setTeacherId={setTeacherId}
				canSave={canSave}
				selectedChildId={selectedChildId}
				saveContext={saveContext}
			/>
		</section>
		{/* <footer className='footer' export-ignore='true'>

      <h2>Формат файла</h2>
      <div className='radio-input-container'>
        <div className="classRadio">
          <input
            id="pdf"
            type="radio"
            name="save"
            defaultChecked
            value="pdf"
            onChange={() => setFileFormat('pdf')}
          />
          <label htmlFor="pdf">PDF (рекомендовано)</label>
          <input
            id="jpg"
            type="radio"
            name="save"
            value="jpg"
            onChange={() => setFileFormat('jpg')}
          />
          <label htmlFor="jpg">JPG</label>
        </div>
      </div>
      <div className='button-container'>
        <button onClick={() => { download('teacher'); setVisibleAlert(true) }}>
          {isLoading?.teacher ? (
            <div className="preloader">
              <div className="spinner" style={{ border: "3px solid #f3f3f3", borderTop: " 3px solid transparent" }}></div>
            </div>
          ) : (
            <img src={saveIcon1} alt='save' className='save-icon' />
          )}
          Скачать для педагога
        </button>
        <button onClick={() => { download('parent'); setVisibleAlert(true) }}>
          {isLoading?.parent ? (
            <div className="preloader">
              <div className="spinner" style={{ border: "3px solid #ee7a45", borderTop: " 3px solid transparent" }}></div>
            </div>
          ) : (
            <img src={saveIcon2} alt='save' className='save-icon' />
          )}
          Скачать для родителя
        </button>
      </div>
    </footer> */}
	</ColorContainer>
	);
}

export default MainPage;

function checkActiveLesson() {
	const lessonList = document.querySelectorAll('.lesson-list');
	const pickedLisson = document.getElementById('lesson-subject').textContent;

	lessonList.forEach(lesson => {
		if (lesson.textContent === pickedLisson) {
			lesson.classList.add('active');
		} else {
			lesson.classList.remove('active');
		}
	});
}

function DisplayLessonList(props) {
	const {
		setDataSkill,
		setDataName,
		updateSkillItem,
		setVisibleSliderBlock,
		criterionRequestParam,
		setCriterionRequestParam,
		setCriterionError,
	} = props;

	const handleClick = (value, name) => {
		setCriterionRequestParam(prevState => ({ ...prevState, direction: name }));

		const dateBirthValue = criterionRequestParam.dateBirthValue;

		setVisibleSliderBlock(prevState => ({ ...prevState, direction: true }));
		if (typeof setCriterionError === 'function') {
			setCriterionError('');
		}

		// Criteria require both age and subject — do not call upstream with empty age.
		if (dateBirthValue && dateBirthValue !== 'null') {
			handleRequest(dateBirthValue, name)
				.then((data) => {
					setDataSkill(data);

					const skillKeys = Object.keys(data);
					const initialSkillItem = Object.fromEntries(skillKeys.map((key) => [key, 0]));

					updateSkillItem(initialSkillItem);
				})
				.catch((err) => {
					const message = err?.apiMessage || err?.message || 'Не удалось загрузить критерии';
					if (typeof setCriterionError === 'function') {
						setCriterionError(message);
					}
					setDataSkill([]);
					updateSkillItem([]);
					setVisibleSliderBlock((prev) => ({ ...prev, direction: false }));
				});
		}


		document.querySelector(".picked-lesson").classList.remove("red-border");
		setDataName({ name: name, value: value });
	}
	return lessonList.map((lesson, index) => (
		<p className='lesson-list' key={index} value={lesson.value} onClick={() => handleClick(lesson.value, lesson.name)}>{lesson.name}</p>
	))
}

const togleVisible = (id) => {
	const element = document.getElementById(id);
	if (element.style.display === "none") {
		element.style.display = "block";
	} else {
		element.style.display = "none";
	}
};


const manySkill = {
	general: [
		'Коммуникативные навыки',
		'Математика',
		'Чтение и письмо',
		'Мотивация',
		'Развитие речи/Звукопроизношение',
		'Эмоциональный интеллект и воля',
		'Окружающий мир',
		'Память/Внимание/Мышление',
		'Творчество',
		'Физическое/моторное развитие',
	],
	english: [
		'Словарный запас',
		'Память/Внимание/Мышление',
		'Мотивация/Интерес к языку',
		'Речь',
		'Восприятие английской речи на слух',
		'Произношение',
	],
	speech: [
		'Связная речь, мышление',
		'Произношение звуков',
		'Различение звуков на слух',
		'Мелкая моторика, письмо',
		'Эмоциональный интеллект',
		'Словарный запас',
		'Выразительность/темп речи',
		'Составление предложений'
	]

}